// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import DatePicker from 'react-datepicker';
  import {addDays}  from 'material-ui/DatePicker/dateUtils'
  import TimeField from 'react-simple-timefield';
  // import TimePicker from 'react-times';
  import TimePicker from 'react-gradient-timepicker';


  class AddBulkBooking extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        customer_search_list: [],
        details: {
            venue: '',
            starting_date:'',
            ending_date: '',
            slot_time: '',
            courts: [],
            amount: 0,
            cust_name: '',
            mobile_no: '',
            cust_mobile_no: '',
            customer_id: '',
            game_type: 0,
            starting_time:'00:00',
            ending_time:'00:00',
            reason:3,
            discount_amount:0,
            advance_amount:0,
            reamining_amount:0,
            total_price:0,
            net_amount:0,
            payment_mode:''
        },
        failed_list:[],
        game_list:[],
        message:'',
        venue_list: [],
        court_list: [],
        checkedBoxes:[],
        dayscheckedBoxes:[],
        blocked_court_list:[],
        available_court_list:[],
        isChecked: false,
        dialog_open_cust: false,
        search: false,
        time:'',
        previous_bulk_booking:'',
        blocked_for_bulk:'',
        available_for_bulk:'',
        submit_pressed:false,
        dialog_open_court_list:false,
        dialog_open_failed_list:false,
        show_booking_option:false,
        loading: false,
        cart:{},
        payment_modes:[],
        message:''
      };
      this.handleVenueChange = this.handleVenueChange.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
      this.searchCustomer = this.searchCustomer.bind(this);
      this.handleStartDate = this.handleStartDate.bind(this);
      this.handleEndDate = this.handleEndDate.bind(this);
      this.onStartTimeChange = this.onStartTimeChange.bind(this);
      this.onTimeChange = this.onTimeChange.bind(this);
      this.handleBooking = this.handleBooking.bind(this);
      this.handleGameChange = this.handleGameChange.bind(this);
    }
  
    componentDidMount() {
        this.getVenueList();
        this.paymentModes()
    }

    getVenueList(){
        const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_buddy/`;
         const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => {this.setState({ venue_list: data.result, game_list: data.result[0].games}), this.getCourtList(data.result[0].id,data.result[0].games[0].game_id)})
           .catch(error => error);
    }

    paymentModes(){
     const url = `${getLocationOrigin()}/eagleeye/get_payment_modes/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({payment_modes:data.payment_modes});
           // alert("fix");
       }).catch(error => error);
    }

    
    
    getCourtList(venue_id,game){
        var new_selected_one =  Object.assign({}, this.state.details);
        new_selected_one['venue'] = venue_id
        new_selected_one['game_type'] = game
        this.setState({details: new_selected_one});
        const url = `${getLocationOrigin()}/court/getCourt/?venue_id=${venue_id}&game=${game}`;
        const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({ court_list: data.results}))
           .catch(error => error);
    }

    searchCustomer() {
        {this.state.details.mobile_no?this.getSearchList(this.state.details.mobile_no):
          alert('Search cannot be blank')}
    }

    handleCustomerSubmit(){
        console.log('post');
          
        const url = `${getLocationOrigin()}/eagleeye/add_new_customer/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                            'customer_name': this.state.details.cust_name,
                            'customer_mobile': this.state.details.mobile_no,
                          });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .catch(error => {
            console.log(error);
            alert(error.message);
          })
          .then(data => {
            if(data.success){
              var cust = Object.assign([], this.state.details);
              cust.push({'id': data.customer.id, 'name': data.customer.name, 'mobile_no':data.customer.mobile_no});
              this.setState({customer_search_list: cust});
              alert(data.message);
              this.handleClose();
            } else {
              alert(data.message);
            }
           });
    }

    getSearchList(mobile_no) {
        const url = `${getLocationOrigin()}/eagleeye/search/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({customer_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }

    setSearch(name, customer_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.details);
        new_selected_one['customer_id'] = customer_id
        new_selected_one['mobile_no'] = mobile_no
        new_selected_one['name'] = name
        this.setState({details: new_selected_one, search: false});
    }

    handleVenueChange(event){
        const selected_venue_id = event.target.value;
        this.state.game_list = this.state.venue_list.filter(venue => venue.id == selected_venue_id)[0].games
        const name = event.target.name;
        var new_selected_one =  Object.assign({}, this.state.details);
        new_selected_one[name] = event.target.value
        new_selected_one['game_type'] = this.state.game_list[0].game_id
        this.setState({details: new_selected_one});
        if(event.target.value != 'true'){
          this.getCourtList(event.target.value,this.state.game_list[0].game_id)
        }
      }

    handleChange(event) {
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.details);
        new_value[name] = event.target.value
        this.setState({details: new_value});
    }

    handleGameChange(event){
    const game = event.target.value;
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.details);
    new_selected_one[name] = game
    this.setState({details: new_selected_one});
    if(event.target.value != 'true'){
      this.getCourtList(this.state.details.venue,game)
    }
  }

    handleOpen = () => {
        this.setState({dialog_open_cust:true,dialog_open_failed_list:true});
    };
    
    handleClose = () => {
    this.setState({dialog_open_cust:false, dialog_open_court_list:false,dialog_open_failed_list:false,previous_bulk_booking:false});
    };

    // onTimeChange = time => {
    //   var new_selected_one =  Object.assign({}, this.state.details);
    //   new_selected_one['ending_time'] = time
    //   this.setState({details:new_selected_one })
    // }

    // onStartTimeChange = time => 
    // {
    //   var new_selected_one =  Object.assign({}, this.state.details);
    //   new_selected_one['starting_time'] = time
    //   this.setState({details:new_selected_one })
    // }

    onStartTimeChange(options) {
      var new_selected_one =  Object.assign({}, this.state.details);
      new_selected_one['starting_time'] = options['format24']
      this.setState({details:new_selected_one })
    }

    onTimeChange(options) {
      var new_selected_one =  Object.assign({}, this.state.details);
      new_selected_one['ending_time'] = options['format24']
      this.setState({details:new_selected_one })
    }
    

    handleCheckbox = (e, s) => {
        const checkedBoxes = [...this.state.checkedBoxes];
        if(e.target.checked) {
            checkedBoxes.push(s)
        } else {
            const index = checkedBoxes.findIndex((ch) => ch.id === s.id);
            checkedBoxes.splice(index, 1);
        }
        this.setState({checkedBoxes:checkedBoxes});
    }

    handleDaysCheckbox = (e, s) => {
        const dayscheckedBoxes = [...this.state.dayscheckedBoxes];
        if(e.target.checked) {
            dayscheckedBoxes.push(s)
        } else {
            const index = dayscheckedBoxes.findIndex((ch) => ch.id === s.id);
            dayscheckedBoxes.splice(index, 1);
        }
        this.setState({dayscheckedBoxes:dayscheckedBoxes});
        console.log(dayscheckedBoxes)
    }

    postBulkBooking(details, courts,days, props) {
        // if(!details.payment_mode){details.payment_mode=Object.keys(this.state.payment_modes)[0]}
        console.log('advance_amount test',this.state.advance_amount)
        console.log('net_amount test',this.state.net_amount)
        console.log('payment_mode test',details.payment_mode)
        if(details.customer_id === ''){
          alert("Enter Customer")
        }
        else if(details.payment_mode == ''){
          alert('Please select payment mode')
        }
        else if(this.state.advance_amount == this.state.net_amount && details.payment_mode == "paylater"){
          alert('De-select paylater in case of full advance amount.')
        }
        else{
          this.setState({loading:true})
          var date = moment(details.starting_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
          var ending_date = moment(details.ending_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
          this.setState({submit_pressed:true})
          if(this.state.details.venue === ''){
            var venue = this.state.venue_list[0].id
          }
          else{
            var venue = details.venue
          } 
          var court_bookings = []
          for( var i in this.state.available_court_list)
          {
            court_bookings.push(this.state.available_court_list[i].id)
          }
            const url = `${getLocationOrigin()}/eagleeye/advance_bulk_booking/`;

            const options = {...defaultOptions};
            options['method'] = 'post';
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'customer_id': details.customer_id,
                                'court_booking_ids': court_bookings,
                                'venue': venue,
                                'courts':courts,
                                'days':days,
                                'start_time': details.starting_time,
                                'end_time': details.ending_time,
                                'date': date,
                                'ending_date':ending_date,
                                'reason':details.reason,
                                'discount_amount':details.discount_amount,
                                'total_amount':this.state.total_price,
                                'net_amount':this.state.net_amount,
                                'advance_amount':this.state.advance_amount,
                                'reamining_amount':this.state.reamining_amount,
                                'payment_mode':details.payment_mode
                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                  
                // alert(response.message);
                this.setState({loading:false,dialog_open_failed_list:true,failed_list:response.failed_slots,message:response.message})
                // props.history.goBack();
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                this.setState({loading:false})
            });
        }
      }

      check_availability(data, courts,days,props) {
        if(courts.length === 0){
          alert("select court")
        }
        else if(days.length === 0){
            alert("select day")
        }
        else if(data.starting_date === ''){
            alert("Enter Start Date")
        }
        else if(data.ending_date === ''){
            alert("Enter End Date")
        }
        else if(data.starting_time === ''){
            alert("Enter Start Time")
        }
        else if(data.ending_time === ''){
            alert("Enter End Time")
        }
        else if(data.reason === ''){
          alert("Enter Reason")
        }
        else if(data.reason == 3 && !data.customer_id){
          alert("Select Customer")
        }
      else{
        this.setState({loading:true})
        var date = moment(data.starting_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
        var ending_date = moment(data.ending_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
        const url = `${getLocationOrigin()}/eagleeye/check_availability_for_bulkbooking/`;
        const options = {...defaultOptions};
        if(this.state.details.venue === ''){
          var venue = this.state.venue_list[0].id
        }
        else{
          var venue = data.venue
        } 
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                            'venue': venue,
                            'courts':courts,
                            'days':days,
                            'start_time': data.starting_time,
                            'end_time': data.ending_time,
                            'date': date,
                            'ending_date': ending_date,
                            'reason':data.reason
                          });
        console.log('Going to fetch');
        console.log(options['body'])
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then((response) => {  
            console.log('response')
            console.log(response)    
            if(!response.success){
              alert(response.message)
            }
            else if(response.available_slot.length > 0 || response.blocked_slot.length > 0 || response.total_slots > 0 || response.previous_bulk_booking ){
              this.setState({dialog_open_court_list:true, available_court_list:response.available_slot, blocked_court_list:response.blocked_slot, total_slots:response.total_slots ,message:response.message,no_of_available_slots:response.available_slot.length,no_of_blocked_slots:response.blocked_slot.length, total_price:response.total_price,advance_amount:response.total_price, net_amount:response.total_price,reamining_amount:0}); 
              // if(response.available_for_bulk && response.available_for_bulk > 0){
              //   this.setState({ total_slots:response.total_slots,no_of_available_slots:(response.available_slot.length + response.available_for_bulk),message:response.message,available_for_bulk:response.available_for_bulk})
              // } 
              if(response.blocked_for_bulk && response.blocked_for_bulk){
                this.setState({total_slots:response.total_slots ,no_of_available_slots:response.available_slot.length,blocked_for_bulk:response.blocked_for_bulk,message:response.message,no_of_blocked_slots:(response.blocked_slot.length)})
              }
              if(response.previous_bulk_booking){
                this.setState({previous_bulk_booking:response.previous_bulk_booking});
              }
            } 

            else{
              alert("No Slot Matched")
            }  
            this.setState({loading:false})
              // alert(response.message);
              // props.history.goBack();
            })
          .catch((error) => {
            console.log(error);
            alert(error.message);
            this.setState({loading:false})
          });
        }
      }

    handleBooking(event){
      this.postBulkBooking(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes,this.props)
    }

    handleFormSubmit(event){
        event.preventDefault();
        this.check_availability(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes,this.props)
        // this.postBulkBooking(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes, this.props)
    }

    handleStartDate(date){
      var new_selected_one =  Object.assign({}, this.state.details);
      new_selected_one['starting_date'] = date
      this.setState({details:new_selected_one })
    }

    handleEndDate(date){
      var new_selected_one =  Object.assign({}, this.state.details);
      new_selected_one['ending_date'] = date
      this.setState({details:new_selected_one })
    }

    getPricing = () => {
      this.setState({dialog_open_court_list:false})
      let available_slot = this.state.available_court_list
      let result = []
      available_slot.forEach((slot)=>{
        let temp_slot = {
         'date':'',
         'court_booking_ids':[],
         'court_ids':[],
         'start_time':'',
         'end_time':''
         }
        let match = result.find(each=> each.start_time == slot.start_time && each.date == slot.date)
        if(match){
          match.court_ids.push(slot.court_id)
          match.court_booking_ids.push(slot.id)
        }
        else{
          temp_slot.date = slot.date
          temp_slot.court_booking_ids.push(slot.id)
          temp_slot.court_ids.push(slot.court_id)
          temp_slot.start_time = moment(slot.start_time,"HH:mm:ss").format('hh:mm A')
          temp_slot.end_time = moment(slot.end_time,"HH:mm:ss").format('hh:mm A')
          temp_slot.tag = 'bulk'
          result.push(temp_slot)
        }
      }
      )

      console.log(result)
      if(this.state.available_court_list.length > 0){
        this.setState({show_booking_option:true,loading:true},()=>{this.addToCart(this.props,result)})
      }
      else{
        alert("No Slots Available")
      }
    }

    addToCart(props,cart_items){
      const url = `${getLocationOrigin()}/cart/add_to_cart/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'customer_id': this.state.details.customer_id,
                          'court_booking_new': cart_items,
                          'source': 'portal'
                        });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => this.setState({cart: data,loading:false,net_amount:data.amount,advance_amount:data.amount,reamining_amount:0}))
        .catch(error => {
          console.log(error);
          alert(error.message);
        })
    }

    removeCartItem(customer_id, item_id){
      const url = `${getLocationOrigin()}/cart/remove_from_cart/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
          'customer_id': customer_id,
          'item_id': item_id,
      });
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({cart: data,show_booking_option:false,available_court_list:[],cust_details:{}}))
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
    }

    applyCoupon(coupon_code){
      var customer_id = this.state.details.customer_id;
      if (customer_id == ""){
          alert("Please select a customer first");
      }
      if (this.state.cart == null){
          alert("Cart cannot be empty");
      }
      else if (this.state.cart.items.length < 1){
          alert("Cart cannot be empty");
      }
      else {
          const url = `${getLocationOrigin()}/cart/apply_coupon/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({
              'customer_id': customer_id,
              'coupon_code': coupon_code,
          });
          return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
              var temp = {};
              if (data.coupon.success != true){
                  temp['details'] =  Object.assign({}, this.state.details);
                  temp['details']['coupon'] = "";
                  alert(data.coupon.message);
              }
              temp['cart'] = data;
              temp['net_amount'] = data.amount;
              temp['advance_amount'] = data.amount;
              temp['reamining_amount'] = 0;
              this.setState(temp);
          })
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
      }
    }

    removeCoupon(coupon_code){
      var customer_id = this.state.details.customer_id;
      if (customer_id == ""){
          alert("Please select a customer first");
      }
      else if (this.state.cart == null){
          alert("Cart cannot be empty");
      }
      else if (this.state.cart.items.length > 1){
          alert("Cart cannot be empty");
      }
      else {
          const url = `${getLocationOrigin()}/cart/remove_coupon/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({
              'customer_id': customer_id,
              'coupon_code': coupon_code,
          });
          return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
              var temp = {};
              temp['details'] =  Object.assign({}, this.state.details);
              temp['details']['coupon'] = "";
              temp['cart'] = data;
              temp['net_amount'] = data.amount;
              temp['advance_amount'] = data.amount;
              temp['reamining_amount'] = 0;
              this.setState(temp);
          })
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
      }
    }

    updateRemainingAmount(event){
        var temp_amount = this.state.net_amount - event.target.value
        this.setState({advance_amount:event.target.value,reamining_amount:temp_amount});

    }

    handleDiscountApply = () => {
      console.log(this.state.details.discount_amount)
      console.log(this.state.total_price)
      if(this.state.details.discount_amount < this.state.total_price){
      var net_price = this.state.total_price - this.state.details.discount_amount
      }
      else{
        var net_price = 0
      }
      this.setState({net_amount:net_price})
      this.setState({advance_amount:net_price,reamining_amount:0})
    }
  
    render() {
      console.log('render')
      console.log(this.state.venue_list)
      console.log(this.state.cart)
      console.log('available_slot',this.state.available_court_list)
      console.log('details',this.state.details)
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Add"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];
      const dialog_actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Continue"
          primary={true}
          onClick={this.getPricing}
        />,
      ];

      const okaction = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleClose}
        />
      ];

      var days = [{"name":"Monday","id":0},{"name":"Tuesday","id":1},{"name":"Wednesday","id":2},{"name":"Thrusday","id":3},{"name":"Friday","id":4},{"name":"Saturday","id":5},{"name":"Sunday","id":6}]

      return(
        <div style={styles.container}>
          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12 label_blue_1">
              <h3 style={{textAlign:'center'}}>Bulk Booking</h3>
            </div>
            {this.state.loading === true ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}>loading...</div>
              </div>
            :
            <div>
            <form  className="validated-form form-horizontal" onSubmit={this.handleFormSubmit}>
            
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.details.venue}
                onChange={this.handleVenueChange}>
                {/* <option value>-------</option> */}
                {
                  this.state.venue_list.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type
              </div>
              <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.details.game_type}
                onChange={this.handleGameChange}>
                {
                  this.state.game_list.map((x, index) => (
                  <option key={x.game_id} value={x.game_id}>{x.game_name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Reason
              </div>
              <select name="reason" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {/* <option value>-------</option> */}
                <option key='3' value='3'>Customer</option>
                <option key='4' value='4'>Tournament</option>
                <option key='5' value='5'>Other</option>
              </select>
            </div>

            { this.state.details.reason == 3 &&
              <div style={styles.items} className='col-md-12'>
                <div style={styles.item_header} className="col-md-6">
                Customer
                </div>
                <div className="col-md-6 input-group">
                    <input type="text" name="mobile_no" className="form-control"
                    placeholder="Search for.. " value={this.state.details.mobile_no} onChange={this.handleChange}/>
                    <span className="input-group-btn">
                    <button className="btn btn-default glyphicon glyphicon-search"
                    type="button" onClick={this.searchCustomer}></button>
                    </span>
                </div>
                        {this.state.search?
                        <div className="col-md-12 btn-group">
                            {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                        style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                        :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                        <div className="alert alert-danger">Search customer not found</div>
                        <div>
                        <RaisedButton
                        onClick={this.handleOpen}
                        label="Add"
                        style={{float:'right'}}
                        secondary={true}
                        />
                        <Dialog
                        actions={actions}
                        modal={false}
                        open={this.state.dialog_open_cust}
                        onRequestClose={this.handleClose}
                        >
                        <div>
                            <div style={styles.main_header} className="col-md-12">
                            <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                            </div>
                            <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Name
                            </div>
                            <input type="text" style={styles.input} name="cust_name" className="required"
                                value={this.state.value} onChange={this.handleChange}/>
                            </div>

                            <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Mobile No
                            </div>
                            <input type="number" style={styles.input} name="cust_mobile_no" className="required"
                                value={this.state.details.mobile_no} onChange={this.handleChange}/>
                            </div>
                        </div>
                        </Dialog>
                    </div>
                    </div>
                }</div>:''}
            </div>
            }
            
            {this.state.court_list.length > 0 && 
            <div>
            <div style={styles.items} className="col-md-12">
                <div style={styles.court_list}>
                {
                  this.state.court_list.map((x, index) => (
                    <label>
                    <input type="checkbox"
                    checked={this.state.checkedBoxes.find((ch) => ch.id === x.id)}
                    onChange={(e) => this.handleCheckbox(e, x)}
                  />
                  <div key={x.id} value={x.id}>{x.name}</div>
                  </label>
                  ))
                }
                </div>
            </div>

            <div style={{padding: '1%', display:'flex', flexDirection: 'row'}}>
            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={this.state.details.starting_date} onChange={this.handleStartDate} />
            </div>

            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                To
              </div>
              <DatePicker selected={this.state.details.ending_date} onChange={this.handleEndDate} />
            </div>
            </div>

            <div style={styles.items} className="col-md-12">
            <div style={styles.court_list}>
                {
                  days.map((x, index) => (
                    <label>
                    <input type="checkbox"
                    checked={this.state.dayscheckedBoxes.find((ch) => ch.id === x.id)}
                    onChange={(e) => this.handleDaysCheckbox(e, x)}
                  />
                  <div style={{paddingLeft: '3%', paddingRight:'3%',fontSize:12}} key={x.id} value={x.id}>{x.name}</div>
                  </label>
                  ))
                }
            </div>
            </div>

           {/* <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                    <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Start Time </span>
                    <div style={{width:'77%'}}>
                        <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.details.starting_time} name='start_time' onTimeChange={this.onStartTimeChange} />
                    </div>
                </div>
                <div style={styles.item_header} className="col-md-6">
                    <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>End Time </span>
                    <div style={{width:'77%'}}>
                        <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.details.ending_time} name='end_time' onTimeChange={this.onTimeChange} />
                    </div>
                </div>
            </div>*/}

            <div style={styles.items} className="col-md-12">
                <div style={{width:'50%'}} className="col-md-6">
                    <div style={styles.item_header} className="col-md-6">
                        <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>Start Time </span>
                    </div>
                    <div className='col-md-6'>

                        <TimePicker
                          time={this.state.details.starting_time}
                          headerColor='#84888A'
                          color1='#84888A'
                          className="timepicker"
                          placeholder="Start Time"
                          onSet={this.onStartTimeChange}
                        />
                    </div>
                </div>
                <div style={{width:'50%'}} className="col-md-6">
                    <div style={styles.item_header} className="col-md-6">
                        <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>End Time </span>
                    </div>
                    <div className='col-md-6'>

                      <TimePicker
                            time={this.state.details.ending_time}
                            headerColor='#84888A'
                            color1='#84888A'
                            className="timepicker"
                            placeholder="End Time"
                            onSet={this.onTimeChange}
                          />
                    </div>
                </div>
            </div>

            <div style={{display:'flex', flexDirection: 'row',marginTop:10}} className="col-md-12">
              <div style={{fontSize:'16', color:'red'}}>* for 23:00:00 slot enter end time as 23:59:00</div>
            </div>


            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Check Availability & Get Pricing"/>
                {this.state.previous_bulk_booking.length > 0 ?
                  <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                      <Dialog
                        actions={okaction}
                        modal={false}
                        open={this.state.previous_bulk_booking}
                        onClick={this.handleClose}
                        autoDetectWindowHeight={true}
                        autoScrollBodyContent={true}
                        scroll={scroll}
                        dividers={scroll === 'paper'}
                      >

                      <div style={styles.main_header} className="col-md-12">
                        <h4 style={{textAlign:'center'}}>These bulk bookings are conflicting, so change date or time and try again </h4>
                      </div>
                      <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                        <div className="col-md-3">
                                Date
                        </div>
                        
                        <div className="col-md-3">
                                Time
                        </div>
                        
                        <div className="col-md-3">
                                Days
                        </div>
                        <div className="col-md-3">
                                Court
                        </div>
                      </div>
                        <div className="col-md-12" style={{flexDirection:'row',textAlign:'center','padding':"5px"}}>
                            {this.state.previous_bulk_booking && this.state.previous_bulk_booking.map((Bulk_book,index) =>
                            <div className="col-md-12" style={{flexDirection:'row',textAlign:'center','marginTop':"2px",'backgroundColor':"#cfd4d3"}}>  
                              <div className="col-md-3">
                                {Bulk_book.start_date} - {Bulk_book.end_date}
                              </div>
                              
                              <div className="col-md-3">
                                {Bulk_book.start_time} - {Bulk_book.end_time}
                              </div>
                              <div className="col-md-3" >
                                {Bulk_book.days}
                              </div>
                              <div className="col-md-3">
                                {Bulk_book.court.map((crt,index) =>
                                  <div><label>{crt.name}
                                  </label></div>
                                  )}
                              </div>
                            </div>
                            )}
                        </div>
                        </Dialog>
                    </div>
                    :

                 
                <Dialog
                    actions={dialog_actions}
                    modal={false}
                    open={this.state.dialog_open_court_list}
                    onRequestClose={this.handleClose}
                    scroll={scroll}
                    dividers={scroll === 'paper'}
                  >
              <div>
                {this.state.blocked_court_list.length > 0 &&
                <div style={styles.main_header} className="col-md-12">
                  <h4 style={{textAlign:'center'}}>Following Slots are not available, press Continue to book the available slots or cancel.</h4>
                </div>
                }
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                      
                <div className="col-md-4">
                    Total Slots
                  </div>
                  <div className="col-md-4">
                    Available Slots
                  </div>
                  <div className="col-md-4">
                    Unavailable Slots
                  </div>
                </div>
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                <div className="col-md-4">
                    {this.state.total_slots}
                  </div>
                  <div className="col-md-4">
                    {this.state.no_of_available_slots}
                  </div>
                  <div className="col-md-4">
                    {this.state.no_of_blocked_slots}
                  </div>
                </div>
                
                {this.state.blocked_court_list.length > 0 &&
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center', marginTop:10}}>
                  <div className="col-md-4">
                    Date
                  </div>
                  <div className="col-md-4">
                    Court 
                  </div>
                  <div className="col-md-4">
                    Time
                  </div>
                  </div>
                }
                {this.state.blocked_court_list.length > 0 ?
                <div>
                {this.state.blocked_court_list.map((list,index)=>
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                  <div className="col-md-4">
                    {list.date}
                  </div>
                  <div className="col-md-4">
                    {list.court.name}
                  </div>
                  <div className="col-md-4">
                    {list.start_time}
                  </div>
                  </div>
                  )}
                  </div>
                  :
                  <div className="col-md-12" style={{flexDirection:'row',textAlign:'center', marginTop:20}}>
                    <div>All slots Available!!</div>
                  </div>
                }
                </div>
            </Dialog>
          }
            </div>
            </div>
            }
          </form>

          <div className="col-md-12">
              <Dialog
                    actions={okaction}
                    modal={false}
                    open={this.state.dialog_open_failed_list}
                    onRequestClose={this.handleClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                    // scroll={scroll}
                    // dividers={scroll === 'paper'}
                  >
              <div >
              {this.state.failed_list && this.state.failed_list.length > 0 ?
                <div style={styles.main_header} className="col-md-12">
                <h4 style={{textAlign:'center'}}> Failed To Book </h4>
                  {this.state.failed_list.map((list,index) =>
                    <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                      <div className="col-md-4">
                        {list.name}
                      </div>
                      <div className="col-md-4">
                        {list.date}
                      </div>
                      <div className="col-md-4">
                        {list.time}
                      </div>
                    </div>
                      ) 
                  }
                </div>  
                  :
                  <h4 style={{textAlign:'center'}}>{this.state.message} </h4>
              }
               </div> 
               </Dialog>
            </div>

          { this.state.show_booking_option &&
            <div style={styles.items} className="col-md-12">

              {Object.keys(this.state.cart).length > 0 ?
                  this.state.cart.items ?
                      this.state.cart.items.map((item, index) => {
                          return(
                              <div style={styles.cart_item_container} className="col-md-12" key={index}>
                                  <div style={styles.cart_item_image} className="col-md-2">
                                      <img src={
                                          item.object.image ?
                                          (item.object.image.indexOf("assets.sporthood.in") > 0 && item.object.image.indexOf("api.sporthood.in") > 0) ?
                                          item.object.image :
                                          `https://api.sporthood.in/media/${item.object.image}`
                                          :
                                          null
                                      }/>
                                  </div>
                                  <div className="col-md-6">
                                      <div style={styles.cart_item_title} className="col-md-12">
                                          Bulk Booking
                                      </div>
                                      {/* <div style={styles.cart_item_remove} className="col-md-8">
                                          <i className="fa fa-trash"></i>
                                          &nbsp;
                                          Remove from cart
                                      </div> */}
                                      <button className="btn btn-sm" type="button" style={styles.cart_item_remove} onClick={() => this.removeCartItem(this.state.details.customer_id, item.id)}>
                                          <i className="fa fa-trash"></i>
                                          &nbsp;
                                          Remove from cart
                                      </button>

                                  </div>

                                  <div style={styles.cart_item_price} className="col-md-4 pull-right">
                                      <div style={styles.cart_item_amount} className="col-md-12">
                                          <i className="fa fa-rupee"></i> {item.invoice_items[0].amount}
                                      </div>
                                      <div style={styles.cart_item_tax} className="col-md-12">
                                          {item.invoice_items[1].description}: <i className="fa fa-rupee"></i> {item.invoice_items[1].amount}
                                      </div>
                                  </div>
                              </div>
                          );
                      })
                    :
                    <div style={styles.cart_empty} className="col-md-12">
                        {/* --- Empty --- */}
                    </div>
                  :
                  ''
                }

              <div style={{display:'flex', flexDirection: 'row',marginTop:10}} className="col-md-12">
                    <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                      Coupon Code
                    </div>
                    {
                        Object.keys(this.state.cart).length > 0 ?
                            this.state.cart.coupon ?
                                this.state.cart.coupon.code ?
                                    <div className="col-md-6">
                                        <input type="text" style={styles.input} name="coupon" className='col-md-3'
                                        disabled={true}
                                        value={this.state.cart.coupon.code} onChange={this.handleChange}/>
                                        <button className="btn btn-sm pull-right col-md-3" type="button" style={{backgroundColor:'#302C35',
                                        color:'#ffffff'}} onClick={() => this.removeCoupon(this.state.cart.coupon.code)}>
                                            Remove Coupon
                                        </button>
                                    </div>
                                    :
                                    <div className="col-md-6">
                                        <input type="text" style={styles.input} name="coupon" className='col-md-3'
                                        // disabled={this.state.sub_details.coupon}
                                        value={this.state.details.coupon} onChange={this.handleChange}/>
                                        <button className="btn btn-sm pull-right col-md-3" type="button" style={{backgroundColor:'#302C35',
                                            color:'#ffffff'}} onClick={() => this.applyCoupon(this.state.details.coupon)}>
                                            Apply Coupon
                                        </button>
                                    </div>
                                :
                                <div className="col-md-6">
                                    <input type="text" style={styles.input} name="coupon" className='col-md-3'
                                    // disabled={this.state.sub_details.coupon}
                                    value={this.state.details.coupon} onChange={this.handleChange}/>
                                    <button className="btn btn-sm pull-right col-md-3" type="button" style={{backgroundColor:'#302C35',
                                        color:'#ffffff'}} onClick={() => this.applyCoupon(this.state.details.coupon)}>
                                        Apply Coupon
                                    </button>
                                </div>
                            :
                            <div className="col-md-6">
                                <input type="text" style={styles.input} name="coupon" className='col-md-3'
                                // disabled={this.state.sub_details.coupon}
                                value={this.state.details.coupon} onChange={this.handleChange}/>
                                <button className="btn btn-sm pull-right col-md-3" type="button" style={{backgroundColor:'#302C35',
                                    color:'#ffffff'}} onClick={() => this.applyCoupon(this.state.details.coupon)}>
                                    Apply Coupon
                                </button>
                            </div>
                    }
                  </div>
                  <div className="col-md-12">
                  {Object.keys(this.state.cart).length > 0 ?
                    this.state.cart.summary ?
                        this.state.cart.summary.map((item, index) => {
                             return(
                                 <div style={{display:'flex', flexDirection: 'row',marginTop:10}} className="col-md-12" key={item.id}>
                                   <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-4">
                                     {item.label}
                                   </div>
                                   <div style={{...styles.item_header, textAlign: "right"}} className="col-md-4 pull-right">
                                       <i className="fa fa-rupee"></i> &nbsp;
                                       {item.value}
                                   </div>
                                 </div>
                             );
                         })
                         : null
                    :
                    null
                  }
                  </div>
                

              <div style={{display:'flex', flexDirection: 'row', marginTop:10}} className="col-md-12">
                  <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                    Advance Amount
                  </div>
                <div className="col-md-6">
                <input type="number" style={styles.input} className="required" name="advance_amount" value={this.state.advance_amount}
                      onChange={(event)=>{this.updateRemainingAmount(event)}}/>
                </div>
              </div>

              <div style={{display:'flex', flexDirection: 'row', marginTop:10}} className="col-md-12">
                  <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                    Remaining Amount
                  </div>
                <div className="col-md-6">
                {this.state.reamining_amount}
                      
                </div>
              </div>

              <div style={{display:'flex', flexDirection: 'row', marginTop:10}} className="col-md-12">
                  <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                    Payment Modes
                  </div>
                 <select name="payment_mode" className="col-md-6" style={styles.item_body} value={this.state.value}
                   onChange={this.handleChange}>
                    <option>--select--</option>
                    {
                       Object.keys(this.state.payment_modes).map((key, index) => (
                       <option key={key} value={key}>{`${this.state.payment_modes[key]}`}</option>
                       ))
                     }
                  </select>
              </div>



              {/* <div style={{display:'flex', flexDirection: 'row', marginTop:10}} className="col-md-12">
                  <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                    Advance
                  </div>
              <div className="col-md-6">
                <input type="number" style={styles.input} name="advance_amount" className="required"
                        value={this.state.details.advance_amount} onChange={this.handleChange}/>
              </div>
              </div> */}

              <div style={styles.button_submit} className="col-md-12">
                   <button
                   className="button1"
                    type="button"
                    value="Submit" 
                    style={{color:'#ffffff',width:130,height:40}}
                    onClick={this.handleBooking} >
                    Submit
                    </button>
              </div>

            </div>
        }
        </div>
        }
          </div>
        </div>
      );
    }
  }
  
  export default AddBulkBooking;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addBulBooking/index.js